"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.chooseFontWeight = void 0;
var chooseFontWeight = function (fontWeight, theme) {
    switch (fontWeight) {
        case 'regular':
            return theme.FontWeightRegular;
        case 'medium':
            return theme.FontWeightMedium;
        case 'semibold':
            return theme.FontWeightSemibold;
        case 'bold':
            return theme.FontWeightBold;
        default:
            return theme.FontWeightRegular;
    }
};
exports.chooseFontWeight = chooseFontWeight;
